"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToastContext", {
    enumerable: true,
    get: function() {
        return ToastContext;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ToastContext = _react.default.createContext({
    provided: false,
    neutral: ()=>({
            remove: ()=>undefined
        }),
    positive: ()=>({
            remove: ()=>undefined
        }),
    negative: ()=>({
            remove: ()=>undefined
        })
});

//# sourceMappingURL=ToastContext.js.map